import angular from 'angular';
import moment from 'moment';

angular
  .module('cxTaskflow')
  .controller('ReadEidDialogCtrl', [
    '$timeout',
    '$element',
    'flySvc',
    '$http',
    'appUrls',
    'close',
    'relationId',
    'relBindSvc',
    readEidDialogCtrl,
  ]);

function readEidDialogCtrl(
  $timeout,
  $element,
  flySvc,
  $http,
  appUrls,
  close,
  relationId,
  relBindSvc,
) {
  var vm = this;
  vm.saving = false;
  vm.cardInformation = null;

  vm.uploadEid = function(eid) {
    vm.cardInformation = eid;
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };

  vm.save = function() {
    vm.saving = true;
    if (!vm.cardInformation) return;
    var model = angular.copy(vm.cardInformation);
    model.relationId = relationId;
    model.dateOfBirth = moment.utc(model.dateOfBirth);
    model.cardExpiryDate = moment.utc(model.cardExpiryDate);

    $http.put(appUrls.api + '/api/relation/UpdateRelationEid', model).then(
      function(result) {
        vm.saving = false;
        relBindSvc.updateRelation(relationId, result.data.changes, null);
        flySvc.success('msgRelationUpdated');
        $element.modal('hide');
        close(null, 500);
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error.data.code, error.data.parameters);
      },
    );
  };
}
